module.exports = __webpack_public_path__ + "img/map-2-f-food@2x.833cdd80.png";